import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center gap-4">
      <div className="absolute">
        <img src={'/hållkoll.png'} alt="HållKoll Logo" width={250} />
      </div>
      <div className="absolute h-72 w-72 animate-spin rounded-full border-b-4 border-primary-500"></div>
    </div>
  );
};

export default LoadingScreen;
